"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderField = void 0;
const joi_1 = __importDefault(require("joi"));
const field_types_1 = require("../../types/field_types");
const datasheet_1 = require("../datasheet");
const text_base_field_1 = require("./text_base_field");
const i18n_1 = require("../../exports/i18n");
class CascaderField extends text_base_field_1.TextBaseField {
    static defaultProperty() {
        return {
            showAll: false,
            linkedDatasheetId: '',
            linkedViewId: '',
            linkedFields: [],
            fullLinkedFields: [],
        };
    }
    static createDefault(fieldMap) {
        return {
            id: datasheet_1.DatasheetActions.getNewFieldId(fieldMap),
            name: datasheet_1.DatasheetActions.getDefaultFieldName(fieldMap),
            type: field_types_1.FieldType.Cascader,
            property: this.defaultProperty(),
        };
    }
    get hasError() {
        const { linkedDatasheetId } = this.field.property;
        return !Boolean(linkedDatasheetId);
    }
    get warnText() {
        const { linkedDatasheetId } = this.field.property;
        return Boolean(linkedDatasheetId) ? '' : (0, i18n_1.t)(i18n_1.Strings.cascader_field_configuration_err);
    }
    validateProperty() {
        return CascaderField.propertySchema.validate(this.field.property);
    }
    cellValueToString(cellValue) {
        if (cellValue == null) {
            return null;
        }
        const showAll = this.field.property.showAll;
        const cv = [cellValue].flat();
        return cv.map(seg => {
            if (!showAll) {
                const segArr = seg.text.split('/');
                return segArr[segArr.length - 1];
            }
            return seg.text;
        }).join('') || null;
    }
    cellValueToFullString(cellValue) {
        if (cellValue == null) {
            return null;
        }
        const cv = [cellValue].flat();
        return cv.map(seg => seg.text).join('') || null;
    }
    isMeetFilter(operator, cellValue, conditionValue) {
        const cellText = this.cellValueToFullString(cellValue);
        return text_base_field_1.TextBaseField._isMeetFilter(operator, cellText, conditionValue, {
            containsFn: (filterValue) => cellText != null && this.stringInclude(cellText, filterValue),
            doesNotContainFn: (filterValue) => cellText == null || !this.stringInclude(cellText, filterValue),
            defaultFn: () => super.isMeetFilter(operator, cellValue, conditionValue)
        });
    }
}
exports.CascaderField = CascaderField;
CascaderField.propertySchema = joi_1.default.object({
    showAll: joi_1.default.bool().required(),
    linkedDatasheetId: joi_1.default.string().required(),
    linkedViewId: joi_1.default.string().required(),
    linkedFields: joi_1.default.array().items(joi_1.default.object({
        id: joi_1.default.string().required(),
        name: joi_1.default.string().required(),
        type: joi_1.default.number().required(),
    })).required(),
    fullLinkedFields: joi_1.default.array().items(joi_1.default.object({
        id: joi_1.default.string().required(),
        name: joi_1.default.string().required(),
        type: joi_1.default.number().required(),
    })).required(),
}).required();
//# sourceMappingURL=cascader_field.js.map